import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';

import '../css/typography.css';

export default class Template extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  };

  render() {
    const { location } = this.props;

    const isRoot = location.pathname === '/';

    return (
      <div>
        <Helmet
          title="Crazy Cool Developers"
          meta={[
            { name: 'description', content: '' },
            { name: 'keywords', content: '' },
          ]}
        />

          <div className="p15" id="logo">
            <h1>
              <Link to="/">
                crazy cool developers
              </Link>
            </h1>
          </div>


         

          <div id="content">
            {this.props.children()}
          </div>

          <div className="colophon">
            <a href="/impressum">impressum</a>
          </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js